/* src/app/ship/address-confidence/address-confidence.component.scss */
.dd-score-header {
  background-color: #E7F2F2;
  padding: 0 2.5rem 1rem;
}
.dd-score-header.no-options {
  background-color: white;
}
@media screen and (min-width: 48rem) {
  .dd-score-header.no-options {
    padding-bottom: 1.5rem;
  }
}
.dd-score-header.no-gauge {
  padding-top: 2.5rem;
}
@media screen and (min-width: 48rem) {
  .dd-score-header {
    padding: 2.5rem 3rem 0;
  }
}
.address {
  font-size: 1.125rem;
  font-weight: 700;
  line-height: 1.5rem;
  margin-bottom: 0.5rem;
}
@media screen and (min-width: 48rem) {
  .address {
    margin-bottom: 0.3rem;
  }
}
.address .greeting {
  font-size: 1.5625rem;
  font-weight: 700;
}
.message {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  margin-bottom: 1rem;
}
@media screen and (min-width: 48rem) {
  .message {
    font-size: 1.125rem;
  }
}
.message .no-score {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.25rem;
}
.message .no-score > span {
  padding: 1.625rem 0;
}
.message .no-score > span:last-of-type {
  padding-bottom: 0;
}
.message .no-score > span.with-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 1rem;
}
.message .no-score > span.with-icon .mat-icon {
  color: #FBD300;
}
.message .no-score > span.with-icon span {
  flex: 1;
}
.message .cached {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.2rem;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1rem;
  margin-top: 1.25rem;
}
.message .cached .mat-icon {
  color: #29A855;
}
.message .cached span {
  flex: 1;
}
.circular-gauge-container {
  width: 100%;
  margin: 0 auto;
  padding: 2rem 2rem 0;
  background-color: #E7F2F2;
}
.circular-gauge-container.no-options {
  background-color: white;
}
@media screen and (min-width: 48rem) {
  .circular-gauge-container {
    display: none;
  }
}
.linear-gauge-container {
  display: none;
}
@media screen and (min-width: 48rem) {
  .linear-gauge-container {
    display: block;
    margin-bottom: 1.5rem;
  }
}
.options {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  row-gap: 1.5rem;
  padding: 1.5rem 1.5rem 0;
}
.options.no-options {
  padding: 0;
}
.options label.custom-radio {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.75rem;
  padding: 1rem;
  border-radius: 0.25rem;
  box-shadow: 0 4px 12px -3px rgba(0, 0, 0, 0.05), 0 2px 5px 0px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  position: relative;
  width: 100%;
  max-width: 28.8675rem;
  border: solid 2px transparent;
  margin-bottom: 0;
}
.options label.custom-radio:not(:last-of-type)::after {
  position: absolute;
  right: 0;
  bottom: -67%;
  width: 100%;
  height: 70%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.5rem;
  padding: 1rem 0;
}
@media screen and (min-width: 48rem) {
  .options label.custom-radio:not(:last-of-type)::after {
    width: 22.5%;
    right: -22.5%;
    bottom: unset;
  }
}
@media screen and (min-width: 48rem) {
  .options label.custom-radio:not(:last-of-type):nth-child(even)::after {
    content: unset;
  }
}
.options label.custom-radio input[type=radio] {
  display: none;
}
.options label.custom-radio input[type=radio]:checked + .circle {
  border: solid 0.5rem #004791;
}
.options label.custom-radio input[type=radio]:checked + .circle.error {
  border-color: #d50000;
}
.options label.custom-radio .option-label {
  position: absolute;
  bottom: -1em;
  right: -2px;
  border-radius: 0.25rem;
  background-color: #e0e9f2;
  color: #004791;
  font-size: 0.8125rem;
  font-weight: 500;
  padding: 0 1em;
}
.options label.custom-radio .circle {
  aspect-ratio: 1/1;
  width: 1.5rem;
  border: solid thin gray;
  border-radius: 50%;
}
.options label.custom-radio .radio-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  column-gap: 0.5rem;
  width: 100%;
}
.options label.custom-radio .radio-content .radio-message {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
.options label.custom-radio .radio-content .radio-message .title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0;
}
.options label.custom-radio .radio-content .radio-message .details {
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.5;
}
.options label.custom-radio .radio-content .radio-message .remark {
  font-size: 0.5625rem;
  font-weight: 500;
  line-height: 1.5;
}
.options label.custom-radio .radio-content .radio-message a {
  text-decoration: underline;
  color: inherit;
  display: inline-flex;
}
.options label.custom-radio .radio-content .message-icon {
  margin-left: auto;
}
.options label.custom-radio .radio-content .message-icon .logo {
  width: 1.5625rem;
}
.options label.custom-radio .radio-content .message-icon .logo.fedex {
  width: 3.125rem;
}
.options label.custom-radio .radio-content .message-icon .mat-icon {
  font-size: 2rem;
  width: 2rem;
  height: 2rem;
}
.options label.custom-radio.selected {
  background-color: #F8FBFB;
  border: solid 2px #004791;
}
.options label.custom-radio.selected.error {
  background: #FCEAE6;
  border: solid 2px #d50000;
}
.actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  row-gap: 0.5rem;
  padding: 1.5rem;
  position: relative;
}
.actions .action {
  padding: 0.62rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  height: 2.75rem;
  flex: 1;
  max-width: 20rem;
}
.actions .action.mat-mdc-outlined-button:not([color]) {
  color: #0662BB;
  border: solid thin #0662BB;
  background-color: white;
}
.actions .action + .remark {
  margin: 0 auto;
  font-size: 0.5625rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem;
}
:host(.address-confidence) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
}
/*# sourceMappingURL=address-confidence.component.css.map */
